import React from "react";
import axios from "axios";
import { useState } from "react";
import { ClearRounded } from "@mui/icons-material";
import { GlobalState } from "context/GlobalContext";
import {
	autoUpdateStoreBasicDetailsData,
	autoUpdatestoreMainFieldsData,
	getColDefaultValue,
	loiDetailsFields,
	newLoiTableColumns,
	storesLinkedTables,
} from "components/EboStoreV4/data";
import { Box, Button, Dialog, DialogActions, Divider, IconButton, Stack, Typography } from "@mui/material";
import RenderInputField from "components/EboStoreV4/CommonComponents/RenderInputFiled/RenderInputFiled";
import AreaAddition from "components/EboStoreV4/CommonComponents/AreaAddition/AreaAddition";
import SecurityDepositBreakdown from "components/EboStoreV4/CommonComponents/SecurityDepositBreakdown/SecurityDepositBreakdown";
import AddFiles from "components/EboStoreV4/CommonComponents/AddFiles/AddFiles";

function CreateNewLoiModal({ modal, setModal, fetchStores }) {
	const { setSnackBar, snackBar, setSnackBarOpen, loginUser, setLoadingOpen } = GlobalState();
	const [newStoreLoiDetailsField, setNewStoreLoiDetailsField] = useState(() => {
		let obj = {};

		loiDetailsFields?.forEach((attr) => {
			obj[attr.key] = getColDefaultValue(attr);
		});
		return obj;
	});

	const convertDataToLinkedTableFormat = (data) => {
		let obj = {};
		obj["eboStoreAreaDetails"] = data?.area_details;
		obj["eboStoreDepositDetails"] = data?.deposit_details;
		loiDetailsFields?.forEach((attr) => {
			if (!obj[attr?.linked_table]) {
				obj[attr?.linked_table] = {};
			}
			obj[attr?.linked_table][attr.key] = data[attr.key];
		});
		return obj;
	};
	const [allFiles, setAllFiles] = useState([]);
	const selectedStore = [];

	const handleAddFile = (data) => {
		setAllFiles([...allFiles, data]);
	};

	const handleModalclose = () => {
		setModal(false);
	};

	const handleFileUpload = async (files, store_code, tableName, callBack) => {
		setLoadingOpen(true);
		let form = new FormData();
		form.append("file", files);
		form.append("store_code", store_code);
		form.append("tableName", tableName);
		await axios
			.post("/api/ebo_store_v4/ebo_store_file_upload", form, {
				headers: { "Content-Type": "multipart/form-data" },
			})
			.then((res) => {
				let { name, publicUrl } = res.data;
				setSnackBarOpen(true);
				setSnackBar({
					...snackBar,
					message: "File uploaded successfully",
					severity: "success",
					anchorOrigin: { horizontal: "center", vertical: "top" },
				});
				callBack(publicUrl);
			})
			.catch((err) => {
				setSnackBarOpen(true);
				setSnackBar({
					...snackBar,
					message: err.message,
					severity: "error",
					anchorOrigin: { horizontal: "center", vertical: "top" },
				});
			});
	};

	const handleFileUploadDetails = async (files, storeCode, tableName) => {
		let updatedData = [];
		const uploadPromises = files.map(async (data) => {
			try {
				const callBack = (res) => {
					console.log("updatedData", res);
					updatedData.push({ ...data, url: res, table_row_id: storeCode });
				};
				let result = await handleFileUpload(data.file, storeCode, tableName, callBack);
				console.log("File upload result:", result); // Ensure the result is logged
			} catch (error) {
				console.error("Error in file upload:", error);
			}
		});
		await Promise.all(uploadPromises);
		return updatedData;
	};

	const handleFormSubmit = async (e) => {
		setLoadingOpen(true);
		e.preventDefault();

		// Create form data for files
		let form = new FormData();
		const file_types = newLoiTableColumns.map((col) => col.key);
		// if (allFiles?.length > 0) {
		// 	let available_files = allFiles.map((file) => file.file_type);
		// 	let difference = file_types.filter((x) => !available_files.includes(x));
		// 	if (difference?.length) {
		// 		setSnackBarOpen(true);
		// 		setSnackBar({
		// 			...snackBar,
		// 			message: `please upload ${difference.join(", ")} files`,
		// 			severity: "warning",
		// 		});
		// 		setLoadingOpen(false);
		// 		return;
		// 	}
		// }

		// Append each file and its metadata
		allFiles.forEach((obj, index) => {
			form.append("metadata", JSON.stringify(obj)); // corresponding metadata
			form.append("files", obj.file); // file
		});
		form.append("tableName", storesLinkedTables.store_loi_details.key);
		// prepare body for loi details.
		const body = { ...convertDataToLinkedTableFormat(newStoreLoiDetailsField) };
		form.append("storeData", JSON.stringify(body));

		await axios
			.post("/api/ebo_store_v4/create-new-store", form, {
				headers: { "Content-Type": "multipart/form-data" },
			})
			.then((res) => {
				if (res.status === 201) {
					setSnackBarOpen(true);
					setSnackBar({
						...snackBar,
						message: `Store created successfully`,
						severity: "success",
					});

					setLoadingOpen(false);
					fetchStores();
					setModal(false);
				}
			})
			.catch((err) => {
				console.log("err", err);
				setSnackBarOpen(true);
				setSnackBar({
					...snackBar,
					message: err?.response?.data?.message ? err?.response?.data?.message : "Error creating store",
					severity: "error",
				});
				setLoadingOpen(false);
			});
	};

	return (
		<Dialog maxWidth="md" fullWidth open={modal} onClose={handleModalclose} component="form" onSubmit={handleFormSubmit}>
			<Box p={2}>
				<Box display="flex" justifyContent="space-between" alignItems="center">
					<Typography variant="h6">Create Store</Typography>
					<Box>
						<IconButton onClick={handleModalclose}>
							<ClearRounded />
						</IconButton>
					</Box>
				</Box>
				<Stack spacing={1} width="100%">
					{" "}
					<Divider orientation="horizontal" />
					<Box display="flex" flexWrap="wrap" columnGap={"10px"} rowGap="10px" width="100%">
						<Typography variant="button" width="100%">
							LOI DETAILS
						</Typography>
						{/* {newStoreLoiDetailsField &&
							loiDetailsFields?.map((row) => {
								return (
									<RenderInputField
										column={{ ...row }}
										data={newStoreLoiDetailsField}
										setData={setNewStoreLoiDetailsField}
										width="24%"
										selectOptObjName={"option_data"}
										dependencyColData={{ ...autoUpdateStoreBasicDetailsData, ...autoUpdatestoreMainFieldsData }}
									/>
								);
							})} */}

						{loiDetailsFields?.map((row) => {
							if (
								(row.key === "customer" || row.key === "distributer") &&
								newStoreLoiDetailsField["channel"] === "EBO"
							) {
								row.constraints.DISPLAY = false;
							} else if (
								(row.key === "customer" || row.key === "distributer") &&
								newStoreLoiDetailsField["channel"] !== "EBO"
							) {
								row.constraints.DISPLAY = true;
							} else if (row.key === "customer" || row.key === "distributer") {
								row.constraints.DISPLAY = false;
							}
							return (
								<RenderInputField
									column={{ ...row }}
									data={newStoreLoiDetailsField}
									setData={setNewStoreLoiDetailsField}
									width="24%"
									selectOptObjName={"option_data"}
									dependencyColData={{ ...autoUpdateStoreBasicDetailsData, ...autoUpdatestoreMainFieldsData }}
								/>
							);
						})}
					</Box>
					<Box>
						{newStoreLoiDetailsField?.store_type_doors?.length > 0 && (
							<AreaAddition
								brands={newStoreLoiDetailsField?.store_type_doors}
								columns={["Carpet Area", "Chargable Area"]}
								state={newStoreLoiDetailsField}
								setState={setNewStoreLoiDetailsField}
							/>
						)}
					</Box>
					<Box>
						{newStoreLoiDetailsField?.security_deposit !== 0 && (
							<SecurityDepositBreakdown
								security_deposit={newStoreLoiDetailsField?.security_deposit}
								state={newStoreLoiDetailsField}
								setState={setNewStoreLoiDetailsField}
							/>
						)}
					</Box>
					<Box>
						<AddFiles
							columns={newLoiTableColumns}
							tableName={storesLinkedTables.store_loi_details.key}
							rowId={123}
							handleAddFile={handleAddFile}
							files={allFiles}
							selectedStore={selectedStore}
						/>
					</Box>
				</Stack>

				<DialogActions sx={{ pt: 2 }}>
					<Button variant="outlined" sx={{ justifySelf: "center" }} onClick={handleModalclose}>
						Cancel
					</Button>
					<Button variant="contained" sx={{ justifySelf: "center" }} type="submit">
						Create
					</Button>
				</DialogActions>
			</Box>
		</Dialog>
	);
}

export default CreateNewLoiModal;
